// extracted by mini-css-extract-plugin
export default {"textAreaBaseStyle":"Textarea_textAreaBaseStyle__2w9S0"};